import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAttachmentsForAccount as GetAttachmentsForAccountQuery,
    GetAttachmentsForAccount_account_files as File,
    GetAttachmentsForAccountVariables,
} from 'nutshell-graphql-types';

import GET_ATTACHMENTS_FOR_ACCOUNT from '../queries/get-attachments-for-account.graphql';

export const useGetAttachmentsForAccount = (
    accountId: string
): {
    files: File[] | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetAttachmentsForAccountQuery,
        GetAttachmentsForAccountVariables
    >(GET_ATTACHMENTS_FOR_ACCOUNT, {
        variables: {
            accountId,
        },
        fetchPolicy: 'cache-and-network',
    });

    return {
        files: data && data.account && data.account.files,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
